const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsConfiguracoes = { name: 'Configurações', pathName: '/configuracoes' }
export default [
  {
    path: '/configuracoes-admin',
    component: () => import('@/modules/configuracoes-admin/views/pages/Configuracoes.vue'),
    meta: {
      title: 'Configurações',
      breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
      allowOnlyMercapromo: true,
    },
    children: [
      {
        path: '',
        component: () => import('@/modules/configuracoes-admin/views/pages/Gerais.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'televendas',
        component: () => import('@/modules/configuracoes-admin/views/pages/Televendas.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'hotsite',
        component: () => import('@/modules/configuracoes-admin/views/pages/Hotsite.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'app',
        component: () => import('@/modules/configuracoes-admin/views/pages/App.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'termos',
        component: () => import('@/modules/configuracoes-admin/views/pages/Termos.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'lojas',
        component: () => import('@/modules/configuracoes-admin/views/pages/Lojas.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'integracoes',
        component: () => import('@/modules/configuracoes-admin/views/pages/Integracoes.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsConfiguracoes],
          allowOnlyMercapromo: true,
        },
      },
    ],
  },
]
